class OrderConfirmationExportOptionsController {
    constructor(
        settingsService, $state, $element, orderConfirmationEmailService, moveFocus, $q, $timeout, breakpointsService, analyticsService) {
        this.showPrintOption = false;
        this.showEmailOption = false;
        this.showDownloadOption = false;
        this.isEmailFormVisible = false;
        this.settingsService = settingsService;
        this.$state = $state;
        this.$element = $element;
        this.orderConfirmationEmailService = orderConfirmationEmailService;
        this.moveFocus = moveFocus;
        this.$q = $q;
        this.$timeout = $timeout;
        this.breakpointsService = breakpointsService;
        this.analyticsService = analyticsService;
    }

    $onInit() {
        this.formSendOrderConfirmation = {};
        if (this.$state.params.orderId) {
            this.orderId = this.$state.params.orderId;
        }

        this.settingsService.getSettingValue('OneSite', 'EnableOrderConfirmationExportOptions').then((exportOptions) => {
            if (exportOptions.length > 0) {
                exportOptions.forEach((option) => {
                    const cleanedOption = option.trim().toLowerCase();
                    switch (cleanedOption) {
                        case 'print':
                            this.showPrintOption = true;
                            break;
                        case 'email':
                            this.showEmailOption = true;
                            break;
                        case 'download':
                            this.showDownloadOption = true;
                            break;
                        default:
                    }
                });
            }
        });
    }

    showExportOptions() {
        return (this.showPrintOption || this.showEmailOption || this.showDownloadOption) && this.$state.includes('shop.confirmation');
    }

    toggleEmailSection() {
        this.isEmailFormVisible = !this.isEmailFormVisible;
        if (this.isEmailFormVisible) {
            this.resetOrderConfirmFormEmail();
        }
        this.errorMessage = undefined;
    }

    resetOrderConfirmFormEmail() {
        if (this.sendOrderConfirmationForm) {
            this.sendOrderConfirmationForm.$setPristine();
            this.sendOrderConfirmationForm.$setUntouched();
            this.confirm = {};
        }
        this.emailSentMessage = null;
        this.errorMessage = null;
    }

    emailSentSuccessfull() {
        this.errorMessage = null;
        this.emailSentMessage = 'Order confirmation email has been sent successfully';
        this.moveFocus('.orderConfirmationExportOptions-sendEmail');
        this.$timeout(() => {
            this.resetOrderConfirmFormEmail();
        }, 5000);
    }

    showEmailErrorMessage(message) {
        this.emailSentMessage = null;
        this.errorMessage = message;
        this.analyticsService.pushError(message);
    }

    sendOrderConfirmation() {
        if (this.$element != null && this.$element.find('#sendOrderConfirmationForm-Email').val().length === 0) { // It is a hack as ng-model (scope.confirm.email) is not updated until email is entered in right format
            this.showEmailErrorMessage('Email address is required.');
        } else if (!this.sendOrderConfirmationForm.$valid) {
            // don't submit to server if client side is not valid
            this.showEmailErrorMessage('Email address is required to be in the format of example@example.com.');
        } else if (this.emailSentMessage) {
            this.resetOrderConfirmFormEmail();
        } else {
            this.sendingEmail = true;
            this.orderConfirmationEmailService.sendOrderConfirmationEmail(this.orderId, this.confirm.email).then((isEmailSend) => {
                if (isEmailSend) {
                    this.emailSentSuccessfull();
                } else {
                    this.showEmailErrorMessage('There is an error sending the email.');
                }
                this.sendingEmail = false;
            });
        }
    }
}

const orderConfirmationExportOptionsControllerComponentDefinition = {
    bindings: {
        emailFormVisibility: '=',
    },
    controller: ['SettingsService', '$state', '$element', 'OrderConfirmationEmailService', 'MoveFocus', '$q', '$timeout', 'BreakpointsService', 'AnalyticsService', OrderConfirmationExportOptionsController],
    template: require('./order-confirmation-export-options.component.html').trim(),
};

module.exports = {
    OrderConfirmationExportOptionsController,
    orderConfirmationExportOptionsControllerComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/order/confirmation/order-confirmation-export-options.component.js